import API_New from "../utils/API_New";

export const Share_Post = (post_data) => {
  return API_New.post(
    `practitioner-service/practitioners/feeds/create`,
    post_data
  );
};
